import { render, staticRenderFns } from "./ConvertBPointsDialogComponent.vue?vue&type=template&id=29f0858c&"
import script from "./ConvertBPointsDialogComponent.vue?vue&type=script&lang=js&"
export * from "./ConvertBPointsDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports